import React from "react";
import { BotBubble } from "./chatBubbles";

function CustomChatBotMessage ({title, message}: any) {
  return (
    <BotBubble>
      <div className="message-title">{title}</div>
      <div className="message-text">{message}</div>
    </BotBubble>
  )
}

export default CustomChatBotMessage;
